import scheduleBus from './scheduleBus'

export default () => {
  const getScheduleBus = scheduleBus('jadwal-bus')

  return [
    ...getScheduleBus
  ]
}
